import { render, staticRenderFns } from "./addOrEdit.vue?vue&type=template&id=6a8b547e&scoped=true&"
import script from "./addOrEdit.vue?vue&type=script&lang=ts&"
export * from "./addOrEdit.vue?vue&type=script&lang=ts&"
import style0 from "./addOrEdit.vue?vue&type=style&index=0&id=6a8b547e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8b547e",
  null
  
)

export default component.exports